// Autogenerated file
export const notificationThresholdTypesEnum = {
    Hour: "Hour",
    Km: "Km",
    Minute: "Minute",
};
export const notificationThresholdTypes = [
    { label: "Час", value: "Hour" },
    { label: "Км.", value: "Km" },
    { label: "Мин.", value: "Minute" },
];
